export default "__VITE_ASSET__BUiTHM6x__"